import { AutocompleteResponseSchema, PlaceDetailsResponseSchema, DEFAULT_PLACE_DETAILS_FIELDS } from './schema';
import type { AutocompleteRequest, PlaceDetailsRequest } from './schema';
import { HTTP_METHOD } from '../../consts';
import type { Transport, ApiCallOptions } from '../../types';

export const createGooglePlacesApi = (transport: Transport) => ({
  /** Search for place predictions based on user search query */
  autocomplete: (params: AutocompleteRequest, options?: ApiCallOptions) =>
    transport('/places:autocomplete', {
      method: HTTP_METHOD.POST,
      body: params,
      deserializer: AutocompleteResponseSchema,
      signal: options?.signal
    }),

  /** Get detailed information about a place by place ID */
  getPlaceDetails: (params: PlaceDetailsRequest, options?: ApiCallOptions) => {
    const { placeId, fields, languageCode, sessionToken } = params;

    // Use provided fields or default fields
    const fieldMask = fields && fields.length > 0 ? fields : DEFAULT_PLACE_DETAILS_FIELDS;

    return transport(`/places/${placeId}`, {
      method: HTTP_METHOD.GET,
      deserializer: PlaceDetailsResponseSchema,
      signal: options?.signal,
      queryParams: {
        fields: fieldMask.join(','),
        ...(languageCode && { languageCode }),
        ...(sessionToken && { sessionToken })
      }
    });
  }
});

export type GooglePlacesApi = ReturnType<typeof createGooglePlacesApi>;
